/**
 * <vote-button>
 * -----------------------------------------------------------------------------
 *
 * @type {Component}
 *
 * -----------------------------------------------------------------------------
 */

parasails.registerComponent('vote-button', {

  //  ╔═╗╦ ╦╔╗ ╦  ╦╔═╗  ╔═╗╦═╗╔═╗╔═╗╔═╗
  //  ╠═╝║ ║╠╩╗║  ║║    ╠═╝╠╦╝║ ║╠═╝╚═╗
  //  ╩  ╚═╝╚═╝╩═╝╩╚═╝  ╩  ╩╚═╚═╝╩  ╚═╝
  props: [
    'event_id',
    'voteindex',
    'text',
    'textcolor',
    'textsize',
    'device_id',
    'bg_color',        // This prop will now be used for the BORDER color
    'frame_color',     // This prop will now be used for the FILL (background) color
    'selectedindex',
    'frame_opacity',   // Opacity for the border color
    'fill_opacity'     // Opacity for the fill color
  ],

  //  ╦╔╗╔╦╔╦╗╦╔═╗╦    ╦╔╗╔╔╦╗╔═╗╦═╗╔╗╔╔═╗╦    ╔═╗╔╦╗╔═╗╔╦╗╔═╗
  //  ║║║║║ ║ ║╠═╣║    ║║║║ ║ ║╣ ╠╦╝║║║╠═╣║    ╚═╗ ║ ╠═╣ ║ ║╣
  //  ╩╝╚╝╩ ╩ ╩╩ ╩╩═╝  ╩╝╚╝ ╩ ╚═╝╩╚═╝╚╝╩ ╩╩═╝  ╚═╝ ╩ ╩ ╩ ╩ ╚═╝
  data: function () {
    return {
      // Removed all image-related data properties as they are no longer used
      // buttonimageFrame: '../images/quizthemes/simple/A-BOX_Frame.png',
      // dynamicFillImage: '../images/quizthemes/simple/A-BOX_Fill.png',
      // buttonsON: [ ... ],
      // buttonsOFF: [ ... ]
    };
  },


  //  ╦ ╦╔╦╗╔╦╗╦
  //  ╠═╣ ║ ║║║║
  //  ╩ ╩ ╩ ╩ ╩╩═╝
  template: `
        <div :class="['answer-button', selectedindex === voteindex ? 'selected' : '']"
             :style="buttonOverallStyle"> <input type="radio" name="n1" :id="buttonID" v-on:click="voteClicked" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; opacity: 0; cursor: pointer; z-index: 4;">

          <label :for="buttonID" style="position: relative; z-index: 3; display: flex; align-items: center; justify-content: center; height: 100%; width: 100%;">
            <div class="votetext">{{text}}</div>
          </label>
        </div>
    `,

  //  ╦  ╦╔═╗╔═╗╔═╗╦ ╦╔═╗╦  ╔═╗
  //  ║  ║╠╣ ║╣ ║  ╚╦╝║  ║  ║╣
  //  ╩═╝╩╚  ╚═╝╚═╝ ╩ ╚═╝╩═╝╚═╝
  mounted: async function() {
    // Removed the image-related line from mounted hook
    // this.dynamicFillImage = this.buttonsOFF[this.voteindex];
  },

  beforeDestroy: function() {

  },

  computed: {
    buttonID: function () { return 'id' + this.voteindex; },
    altText: function () { return '選択肢' + this.voteindex; },

    // New computed property to handle all the button's visual styles
    buttonOverallStyle: function() {
      // Default values
      let effectiveTextColor = this.textcolor || '#000000'; // Default text color
      let effectiveTextSize = this.textsize || '16px';      // Default text size
      let scale = 1;                                        // Default scale (no size change)

      // Logic for size change based on selection
      if (this.selectedindex === this.voteindex) {
          // This button is the selected one
          scale = 1;
      } else if (this.selectedindex !== -1) {
          // This button is NOT selected, but another one IS selected
          scale = 0.95;
      }

      return {
        color: effectiveTextColor,
        'font-size': effectiveTextSize + 'px',
        transform: `scale(${scale})`, // Apply the size transformation
        // Add a transition for smooth animations
        transition: 'transform 0.3s ease-in-out'
      };
    },

    // Removed fillStyles and frameStyles completely
    // fillStyles: function() { ... },
    // frameStyles: function() { ... }
  },

  watch: {},

  methods: {
    voteClicked: function () {
      this.$emit('voteselected');
    },

    press: function(){},
    release: function(){},

    hexToRgba: function(color, alpha) {
      if (!color || typeof color !== 'string') {
        return `rgba(0, 0, 0, ${alpha || 0})`;
      }

      let r, g, b;
      if (color.startsWith('#')) {
        const sanitizedHex = color.slice(1);
        let bigint;
        try {
          bigint = parseInt(sanitizedHex, 16);
        } catch (e) {
          console.warn(`Error parsing hex color: ${color}. Returning original color.`);
          return color;
        }

        if (sanitizedHex.length === 3) {
          r = ((bigint >> 8) & 0xF) * 17;
          g = ((bigint >> 4) & 0xF) * 17;
          b = (bigint & 0xF) * 17;
        } else if (sanitizedHex.length === 6) {
          r = (bigint >> 16) & 255;
          g = (bigint >> 8) & 255;
          b = bigint & 255;
        } else {
          console.warn(`Invalid hex color format: ${color}. Returning original color.`);
          return color;
        }
      } else if (color.startsWith('rgb(') || color.startsWith('rgba(')) {
        const parts = color.match(/\d+(\.\d+)?/g);
        if (parts && parts.length >= 3) {
          r = parseInt(parts[0]);
          g = parseInt(parts[1]);
          b = parseInt(parts[2]);
          return `rgba(${r}, ${g}, ${b}, ${alpha})`;
        } else {
          console.warn(`Invalid rgb/rgba color format: ${color}. Returning original color.`);
          return color;
        }
      } else {
        console.warn(`Unsupported color format for opacity conversion: ${color}. Returning original color.`);
        return color;
      }

      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
  }
});